import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isExistingSpan',
})
export class ExistingSpanPipe implements PipeTransform {
  AccommationMethodExistingId = 51;
  transform(accommodationMethodId: number): boolean {
    return this.AccommationMethodExistingId == accommodationMethodId;
  }
}
